import { BriefingHeadingLevelEnum } from '../enums/briefing-heading-level.enum';

export const briefingHeadingLevelOptions: {label: string; value: BriefingHeadingLevelEnum}[] = [
    {
        label: `Briefings.title.headingLevel.${BriefingHeadingLevelEnum.HEADING_1}`,
        value: BriefingHeadingLevelEnum.HEADING_1
    },
    {
        label: `Briefings.title.headingLevel.${BriefingHeadingLevelEnum.HEADING_2}`,
        value: BriefingHeadingLevelEnum.HEADING_2
    },
    {
        label: `Briefings.title.headingLevel.${BriefingHeadingLevelEnum.HEADING_3}`,
        value: BriefingHeadingLevelEnum.HEADING_3
    },
];
